import { TRootState } from "store";
import { IProductsState } from "./products.types";

export const getProductsSelector = (state: TRootState): IProductsState => state.products;
